export class Establishment {
  etablissement_id: number;
  label: string;
}
